var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0938 6.09375V13.5938C36.0938 14.37 36.7237 15 37.5 15C38.2763 15 38.9062 14.37 38.9062 13.5938V6.09375C38.9062 5.3175 38.2763 4.6875 37.5 4.6875C36.7237 4.6875 36.0938 5.3175 36.0938 6.09375Z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 11.25H41.25C42.0262 11.25 42.6562 10.62 42.6562 9.84375C42.6562 9.0675 42.0262 8.4375 41.25 8.4375H33.75C32.9737 8.4375 32.3438 9.0675 32.3438 9.84375C32.3438 10.62 32.9737 11.25 33.75 11.25Z",
    fill: "#949494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4712 13.1175C41.3981 13.1231 41.325 13.125 41.25 13.125H40.7812V13.5938C40.7812 15.405 39.3112 16.875 37.5 16.875C35.6888 16.875 34.2188 15.405 34.2188 13.5938V13.125H33.75C31.9387 13.125 30.4688 11.655 30.4688 9.84375C30.4688 9.12937 30.6975 8.46938 31.0837 7.93125L30.8381 7.43813C30.2831 6.32812 29.1469 5.625 27.9037 5.625C25.4156 5.625 19.5844 5.625 17.0963 5.625C15.8531 5.625 14.7169 6.32812 14.1619 7.43813L12.3862 10.9913C12.3056 11.1487 12.1444 11.25 11.9662 11.25H7.5C4.65188 11.25 2.34375 13.5581 2.34375 16.4062V35.1562C2.34375 36.5231 2.8875 37.8356 3.85313 38.8031C4.82063 39.7687 6.13313 40.3125 7.5 40.3125H37.5C38.8669 40.3125 40.1794 39.7687 41.1469 38.8031C42.1125 37.8356 42.6562 36.5231 42.6562 35.1562V16.4062C42.6562 15.1556 42.2119 14.01 41.4712 13.1175ZM22.5 15.9375C17.5837 15.9375 13.5938 19.9275 13.5938 24.8438C13.5938 29.76 17.5837 33.75 22.5 33.75C27.4163 33.75 31.4062 29.76 31.4062 24.8438C31.4062 19.9275 27.4163 15.9375 22.5 15.9375ZM22.5 18.75C25.8638 18.75 28.5938 21.48 28.5938 24.8438C28.5938 28.2075 25.8638 30.9375 22.5 30.9375C19.1362 30.9375 16.4062 28.2075 16.4062 24.8438C16.4062 21.48 19.1362 18.75 22.5 18.75Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraicon);
export default __webpack_public_path__ + "static/media/cameraicon.252bac415732a7ec9d4d9ae0879e9d10.svg";
export { ForwardRef as ReactComponent };